<template>
  <span>{{ timeFromNow }}</span>
</template>

<script>
import moment from 'moment';
import { get } from 'lodash';

export default {
  name: 'nuttrema-created-updated',
  props: {
    item: {
      required: true,
      default: null,
    },
    dateAfterDays: {
      type: Number,
      required: false,
      default: 7,
    },
    dateFormat: {
      type: String,
      required: false,
      default: 'll',
    },
  },
  data() {
    return {
      now: new Date(),
      createdAt: null,
      updatedAt: null,
    };
  },
  computed: {
    timeFromNow() {
      let time = this.updatedAt;
      let label = this.$t('label.updated');

      if (this.createdAt === this.updatedAt) {
        time = this.createdAt;
        label = this.$t('label.created');
      }

      const now = moment(this.now);
      const ref = moment(time);

      if (now.diff(ref, 'days') > this.dateAfterDays) {
        return `${label} ${ref.format(this.dateFormat)}`;
      }

      return `${label} ${ref.fromNow()}`;
    },
  },
  mounted() {
    this.createdAt = get(this.item, 'created_at', null);
    this.updatedAt = get(this.item, 'updated_at', null);

    let time = this.updatedAt;

    if (this.createdAt === this.updatedAt) {
      time = this.createdAt;
    }

    const now = moment(this.now);
    const ref = moment(time);

    if (now.diff(ref, 'days') <= this.dateAfterDays) {
      setInterval(() => {
        this.now = new Date();
      }, 60000);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-created-updated.vue